import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import OrgProductPageContent from '@shared/components/organization/product/OrgProductPageContent';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgProductPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:license.key.product.titleLong')}
                description={t('common:license.key.product.description')}
                items={items}></PageHeader>
            <OrgProductPageContent />
        </OrgPageTemplate>
    );
}
